<button class="button {{ buttonClass }}"
        type="button"
        [class.-active]="isActive"
        [disabled]="disabled || (!isToggle() && isActive)"
        [attr.id]="buttonId"
        [attr.title]="label"
        [attr.accesskey]="accessKey"
        (click)="performAction($event)">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" class="button--icon">
    <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>
    <circle cx="8" cy="5.3" r="0.9" fill="currentColor"/>
    <path d="M8 7.3v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</button>
